import { Injectable } from '@angular/core';
import { LeafletService } from '../leaflet.service'
import { ILeafletInstance } from '../leaflet.interface'
import { INgsiMapBaseEntity } from '../../ngsild/interfaces/ngsi-entity.interface'
import L from '../leaflet-plugins-loader';


type LeafletLatLng = [number, number];

@Injectable({
  providedIn: 'root'
})
export class PolylineService {

  constructor(private readonly leafletService: LeafletService) {}

  addOrUpdatePolyline(
    appPluginWidgetId: string,
    entity: INgsiMapBaseEntity,
    overlayPaneType: string,
    instance?: ILeafletInstance
  ) {
    if (!instance) {
      return;
    }

    if (entity?.location?.coordinates) {
      const lineString = entity.location.coordinates as unknown as [number, number][];
      // Convert LineString (long/lat) to Leaflet (lat/long)
      const leafletCoordinates = lineString.map((coords: [number, number]): LeafletLatLng => [coords[1], coords[0]]);

      let polyLine = instance.polylines.get(entity.id) as L.Polyline<any>;

      if (!polyLine) {
        this.createPolyLine(
          appPluginWidgetId,
          entity,
          overlayPaneType,
          leafletCoordinates,
          instance
        );
      } else {
        this.updatePolyLine(
          appPluginWidgetId,
          entity,
          polyLine,
          leafletCoordinates,
          instance
        );
      }
    }
  }

  createPolyLine(
    appPluginWidgetId: string,
    entity: INgsiMapBaseEntity,
    overlayPaneType: string,
    leafletCoordinates: LeafletLatLng[],
    instance: ILeafletInstance
  ) {
    instance.map.createPane(overlayPaneType);
    const plannedPath_OverlayPane = instance.map.getPane(overlayPaneType);

    if (plannedPath_OverlayPane) {
      plannedPath_OverlayPane.style.zIndex = '350';  // Ensure it is rendered below markers
    }

    const polyOptions = {
      color: '#3d25be',
      weight: 2,
      dashArray: '5,5',
      lineJoin: 'miter',
      lineCap: 'square',
      smoothing: 0.15,
      pane: overlayPaneType
    } as any;

    const polyline = L.polyline(leafletCoordinates, polyOptions);
    instance.polylines.set(entity.id, polyline);

    this.leafletService.addLayerByType(appPluginWidgetId, entity.type, instance);
    this.leafletService.addPolylineToLayer(appPluginWidgetId, entity.type, polyline, instance);
  }

  updatePolyLine(
    appPluginWidgetId: string,
    entity: INgsiMapBaseEntity,
    polyLine: L.Polyline,
    leafletCoordinates: LeafletLatLng[],
    instance?: ILeafletInstance
  ) {
    if (!instance) {
      return;
    }

    polyLine.setLatLngs(leafletCoordinates);
    polyLine.redraw();
    instance.polylines.set(entity.id, polyLine);
    this.leafletService.addPolylineToLayer(appPluginWidgetId, entity.type, polyLine, instance);
  }
}
